import React from 'react';
import classNames from 'classnames';
import styles from './tooltip.module.scss';

export const Tooltip: React.FC<{className?: string}> = ({children, className}) => {
    return <div className={classNames(styles.tooltip, className)}>{children}</div>;
};
